exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".summary-card--section[data-v-4deaa5f3] {\n  position: relative;\n  padding: 0 20px;\n}\n.md-icon.md-theme-default.md-icon-font[data-v-4deaa5f3] {\n  color: #fff;\n}\n.summary-card--section-icon[data-v-4deaa5f3] {\n  border-radius: 50%;\n  color: #fff;\n  background: #4caf50;\n  position: absolute;\n  top: 2%;\n  left: 0;\n  -webkit-transform: translateX(-75%);\n          transform: translateX(-75%);\n  scale: 67%;\n}\n", ""]);

// exports
